import WarrantTable from './calculator-table-warrant';
import CappedBonusTable from './calculator-table-capped-bonus';
import DefaultTable from './calculator-table-default';

const tables = {
	warrant: WarrantTable,
	cappedBonus: CappedBonusTable,
	default: DefaultTable,
};

const tableFactory = (el, type) => {
	const TableClass = tables.hasOwnProperty(type) ? tables[type] : tables.default;

	return new TableClass(el);
};

export default tableFactory;
